import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { API_URL } from "@equine-ui-nx/injection-tokens";

@Injectable({
  providedIn: 'root'
})
export class EntriesExposedService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL);


  getEntriesTable(payerReference: string, pageSize: number, pageIndex: number) {
    const ENTRIES_TABLE = `showEntryPayments/getEntriesTableFromPayerReference`;

    const payload = {
      payerReference,
      pageSize,
      pageIndex
    };

    return this.http.post(`${this.apiUrl}/${ENTRIES_TABLE}`, payload);
  }

  getEntryDetailsById(entryId: string) {
    const ENTRY_DETAILS = `showEntryPayments/getEntryDetailsById`;

    const payload = {
      entryId
    };
    return this.http.post(`${this.apiUrl}/${ENTRY_DETAILS}`, payload);
  }

  getEntriesByUserId(payerReference: string, pageSize: number, pageIndex: number) {
    const ENTRIES_TABLE = `showEntryPayments/getEntryDetailsFromPayerReference`;

    const payload = {
      payerReference,
      pageSize,
      pageIndex
    };
    return this.http.post(`${this.apiUrl}/${ENTRIES_TABLE}`, payload);
  }

}
